import type { RateRepository } from '@/core/rate'
import type { UseCase } from '@/core/shared'

export const saveChargerRateSchedule: UseCase<RateRepository, 'saveChargerRateSchedule'> = repository => {
  return async (payload) => {
    await repository.saveChargerRateSchedule(payload)
  }
}
